import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SuspensePageLoading from "../../../components/SuspensePageLoading";
import { links } from "./links";
import MasterData from "../../../components/MasterData";

const Dashboard = lazy(() => import("../../../pages/Dashboard"));
const JobManagement = lazy(() => import("../../../pages/JobManagement"));
const Users = lazy(() => import("../../../pages/Users"));
const AssignJob = lazy(() => import("../../../pages/AssignJob"));
const UpdateJob = lazy(() => import("../../../pages/UpdateJob"));
const Profile = lazy(() => import("../../../pages/Profile"));

const CheckerRoutes = () => {
    
  return (
    <>
      <Sidebar links={links} />
      <MasterData>

      <Suspense fallback={<SuspensePageLoading />}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/job-management" element={<JobManagement />} />
          <Route path="/users" element={<Users />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/job-management/new" element={<AssignJob />} />
          <Route path="/job-management/:id/update" element={<UpdateJob />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
      </MasterData>
    </>
  );
};

export default CheckerRoutes;
